import { createSelector } from 'reselect'

const oeq_question_selector = createSelector(
	[state => state.oeq ],
	oeqState => {
		const question = oeqState.questions[0]
		return {
			entityUID: oeqState.entityUID,
			presentationId: oeqState.presentationId,
			text: question.text,
			serverId: question.serverId,
			icon: question.icon,
			answers: question.answers,
			status: question.status || '',
			orden: 1,
		}
	}
)

export default oeq_question_selector
